export const DOCUMENT_PACK_ROUTE = `/documents`;
